import { toast, MessageType } from '@oliasoft-open-source/react-ui-library';
import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';
import httpStatus from 'http-status';
import { store } from '../store/configureStore';

const resolveErrors = (status: number, err: any) => {
  if ((status === httpStatus.BAD_REQUEST)) {
    // format errors to be joined by command and end sentence with dot
    const errors = err?.errorMessages?.reduce((acc: string, cur: string, i: number, array: string[]) => acc + (i < array.length - 1 ? ', ' : ' . ') + cur);

    toast({
      message: {
        type: MessageType.ERROR,
        heading: err.message,
        content: errors || err.message,
      },
    });
  }
};

const successHandler = (response: AxiosResponse): AxiosResponse => response;

const errorHandler = (error: AxiosError): Promise<AxiosError> => {
  if (axios.isAxiosError(error)) {
    const { response } = error;
    if (response) {
      const { status, data } = response;
      resolveErrors(status, data);
    }
  }

  return Promise.reject(error);
};

const requestHandler = (config: InternalAxiosRequestConfig<any>) => {
  const state = store.getState();
  const newConfig = {
    ...config,
    params: {
      ...config.params,
      customerName: state.entities.customer.selectedCustomer?.customerLabel,
      companyid: state.entities.customer.selectedCustomer?.companyId,
    },
  };

  return newConfig;
};

axios.interceptors.request.use(requestHandler);
axios.interceptors.response.use(successHandler, errorHandler);
